// extracted by mini-css-extract-plugin
module.exports = {"PhotoCropInput":"bfk_a","ReactCrop--disabled":"bfk_b","ReactCrop--circular-crop":"bfk_c"};